import { render, staticRenderFns } from "./account-details.vue?vue&type=template&id=7639ec20&scoped=true"
import script from "./account-details.vue?vue&type=script&lang=js"
export * from "./account-details.vue?vue&type=script&lang=js"
import style0 from "./account-details.vue?vue&type=style&index=0&id=7639ec20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639ec20",
  null
  
)

export default component.exports